import React from 'react';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import Text from './Text';
import { Flex } from 'components/base/layout-components';
import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';

const ToggleButtonGroupWrapper = styled(Flex)`
  border: 1px solid ${getColor('botticelli')};
  width: fit-content;
  border-radius: 4px;
`;

const StyledToggleButtonGroup = styled(ToggleButtonGroup)`
  .MuiToggleButton-root {
    padding: 0;
    border: 0 !important;
    :hover {
      background-color: unset;
    }
  }
  .MuiToggleButton-root.Mui-selected {
    padding: 0;
    background-color: unset;
    p {
      color: ${getColor('dodgerBlue')} !important;
    }
    :hover {
      background-color: unset;
    }
  }
`;

const Toggle = ({
  title = null,
  value = null,
  onChange,
  options = [],
  size = 'medium'
}) => {
  return (
    <ToggleButtonGroupWrapper items='center' padding='smaller'>
      {!!title && (
        <Text pr='0.5rem' whiteSpace='nowrap' size='medium'>
          {title}
        </Text>
      )}
      <StyledToggleButtonGroup
        size={size}
        value={value}
        onChange={onChange}
        exclusive
      >
        {options.map((option, idx) => (
          <ToggleButton value={option} key={idx}>
            <Text
              pl='0.5rem'
              pr='0.5rem'
              color='osloGray'
              size='medium'
              whiteSpace='nowrap'
            >
              {option}
            </Text>
          </ToggleButton>
        ))}
      </StyledToggleButtonGroup>
    </ToggleButtonGroupWrapper>
  );
};

export default Toggle;
